import PropTypes from 'prop-types';
import { HiOutlinePencil } from 'react-icons/hi';
import { withTranslation } from 'react-i18next';

const EditButton = ({ action, t }) => {
    return (
        <button className="btn btn-info btn-sm" onClick={action}>
            <span className="d-none d-sm-block">{t('EDIT_BUTTON')}</span>

            <span className="d-block d-sm-none">
                <HiOutlinePencil size={18} />
            </span>
        </button>
    );
};

EditButton.propTypes = {
    action: PropTypes.func.isRequired,
};

export default withTranslation()(EditButton);
